//Imports
import React, { Fragment } from 'react';

//Hooks
import { useSelector } from 'react-redux';

// Views
import ManageMainView from './views/main';

//Utils
import { HasPermission } from '../../core/security';

// Router
import { Routes, Route, Navigate } from 'react-router-dom';

const routerManage = (props) => {

    const user = useSelector(state => state.securityRedux.user);
    return (
        <Routes>
            {
                HasPermission(user, "manage", [23]) &&
                <Fragment>
                    <Route path='/' element={<Navigate to="/app/manage/main/*" />}></Route>
                    <Route path='main/*' element={<ManageMainView />} />
                </Fragment>
            }
            <Route path="*" element={<Navigate to="/app/error" />} />
        </Routes>
    );
};

export default routerManage